const isEmptyString = (value: string | undefined): boolean => {
  return value === ""
}

export default isEmptyString
